'use strict';

import CSSView from '../common/views/css.js';

module.exports = CSSView;



// WEBPACK FOOTER //
// ./app/scripts/views/css.js